import React, { Component } from 'react';
import './AdminCoupons.css';
import AdminHeaderTool from '../Components/AdminHeaderTool/AdminHeaderTool';
import NabarAdmin from '../Components/NabarAdmin/NabarAdmin';
import AdminTableDetails from '../Components/AdminTableDetails/AdminTableDetails';
import AdminCreateCoupons from '../Components/AdminCreateCoupons/AdminCreateCoupons';
import axios from 'axios'
import { LinkAPI } from '../../../API/API'
import moment from 'moment';
import HandleRes from '../../Components/HandleRes/HandleRes';

import { Link } from 'react-router-dom';
import icon from '../../../image/promocodeSM.svg'

class AdminCoupons extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            search:'',
            name: '',
            amount: Number,
            minorderamount: Number,
            onlyfirstorder: false,
            limit: false,
            limitedtimes: 1,
            validfrom: new Date(),
            validuntill: new Date(),
            EndDate:new Date(),
            startDate:new Date(),
             nameError :'',
            amountError :'',
            limitedtimesError :'',
            limitorfirstError:'',
            minorderamountError:'',
            dateError :'',
            res_donecoupon: false,
            networkError: false,
            errordatamessage: false,
            errordatamessagetext: '',
            hasError: false,
        }
        this.handleChangedate = this.handleChangedate.bind(this);
        this.handleChangedate2 = this.handleChangedate2.bind(this);
        this.getpromocodes()
    }
 
    getpromocodes=()=> {
        const Token = localStorage.getItem("AdminTokenKayn")

        axios.get(`${LinkAPI}/api/admin/getpromocodes`, {
            headers: {
                Authorization: `${Token}`
            }
        }).then(res => {
            this.setState({
                data: res.data.reverse(),
            })
        }).catch(error => {
            this.HandleError(error)
        })
    }
    HandleError = (error) => {
        if (!error.response) {
            this.setState({
                networkError: true
            })
        } else if (error.response.status === 402) {
            localStorage.removeItem("AdminTokenKayn")
            window.location.replace("/SignIn");
        } else if (error.response.data.message) {
            this.setState({
                errordatamessage: true,
                errordatamessagetext: error.response.data.message,
                nameError :'',
                amountError :'',
                limitedtimesError :'',
                limitorfirstError:'',
                minorderamountError:'',
                dateError :'',
            })
        } else {
            this.setState({
                hasError: true,
            })
        }
    }

    handleChangedate(date) {
        let datenew = moment(date).format()
        this.setState({
            validfrom: datenew,
            startDate: date
        });        

    }
    handleChangedate2(date) {
        let datenew = moment(date).format()
        this.setState({
            validuntill: datenew,
            EndDate: date
        });
       
    }
    onlyfirstorder = () => {
        this.setState({
            onlyfirstorder: true,
            limit: false,
            limitedtimes:1,

        });

    }
    limitedtimes = () => {
        this.setState({
            onlyfirstorder: false,
            limit: true
        });

    }
    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        });
    };
    validate = () => {
        let nameError = "";
        let amountError = "";
        let limitedtimesError = "";
        let limitorfirstError = "";
        let minorderamountError = "";
        let dateError = "";

        if (this.state.name.length < 2 || !isNaN(this.state.name)) {
            nameError = "write account name";
        }
        if (this.state.amount <= 0 || isNaN(this.state.amount)) {
            amountError = "wrong amount  ";
        }

        if (this.state.minorderamount <= 0 || isNaN(this.state.minorderamount)) {
            minorderamountError = " wrong Min order amount ";
        }
        // if (this.state.minorderamount <this.state.amount) {
        //     minorderamountError = " wrong Min order amount ";
        // }
        if (this.state.onlyfirstorder === false && this.state.limitedtimes<1|| this.state.onlyfirstorder === false && isNaN(this.state.limitedtimes)) {
            limitedtimesError = "wrong limited times  ";
        }
        if ( moment(this.state.validfrom ).format() >=    moment(this.state.validuntill).format() ) {
            dateError = " wrong date ";         

        }
        if (isNaN(this.state.amount)) {
            amountError = "write amount";
        }
        if (nameError || amountError || minorderamountError || limitedtimesError || limitorfirstError || dateError) {
            this.setState({ nameError, amountError, minorderamountError, limitedtimesError, limitorfirstError, dateError });
            return false;
        }
        return true;
    };
    CreateCoupon = event => {
        event.preventDefault();

        const { name, amount, minorderamount, onlyfirstorder, limitedtimes, validfrom, validuntill } = this.state
        const Token = localStorage.getItem("AdminTokenKayn")
        const isValid = this.validate();
        if (isValid) {
            axios.post(`${LinkAPI}/api/admin/newpromocode`, {
                name: name,
                amount: amount,
                minorderamount: minorderamount,
                onlyfirstorder: onlyfirstorder,
                limitedtimes: limitedtimes,
                validfrom: validfrom,
                validuntill: validuntill
            }, {
                    headers: {
                        Authorization: `${Token}`
                    }
                }).then(res => {
                    this.setState({
                        res_donecoupon: false,
                        networkError: false,
                        errordatamessage: false,
                        errordatamessagetext: '',
                        hasError: false,
                        res_donecoupon: true,
                        nameError :'',
                        amountError :'',
                        limitedtimesError :'',
                        limitorfirstError:'',
                        minorderamountError:'',
                        dateError :'',
                        name: '',
                        amount: Number,
                        minorderamount: Number,
                        onlyfirstorder: false,
                        limit: false,
                        limitedtimes: 1,
                        validfrom: new Date(),
                        validuntill: new Date(),
                        EndDate:new Date(),
                        startDate:new Date(),
                        
                    });
                    this.getpromocodes()
                    setTimeout(() => {
                        this.setState({
                            res_donecoupon:false
                        })
                }, 2000)
                }).catch(error => {
                    this.HandleError(error)
                })
        }
    }
    
    render() {
        let  filteredContantsname = this.state.data.filter(
            (contact)=>{
                return contact.name.toLowerCase().indexOf(this.state.search.toLowerCase())!==-1;
            }
        )
        const itemdatatabel = filteredContantsname.map((x, i) => {
            return <div className=" border-bottom item-table" key={i} >
                <Link to={"/Admin/Coupons/Edit/" + x.name} className="d-block p-3"><img className="mr-3 pointer" src={icon} alt="user kayn" /><span>{x.name}</span></Link>
            </div>
        })

        return (
            <div>
                <div className="row AppEN  mx-0">
                    <div className="col-md-1 px-0 ">
                        <NabarAdmin />
                    </div>
                    <div className=" AdminCoupons Admin col-md-11 px-4">
                        <AdminHeaderTool />
                        <div className="row">
                            <h3 className="col-12 fontsize9 my-0 order-8 order-8 order-md-2">Coupons</h3>

                            <div className="col-md-4 px-2 py-3 order-8 order-md-2">
                                <AdminTableDetails itemdatatabel={itemdatatabel} state={this.state} handleChange={this.handleChange} />
                            </div>
                            <div className="col-md-8 px-4 py-3 order-5">
                                <div className="picbg">
                                    <AdminCreateCoupons state={this.state} CreateCoupon={this.CreateCoupon} handleChange={this.handleChange} handleChangedate={this.handleChangedate} handleChangedate2={this.handleChangedate2} onlyfirstorder={this.onlyfirstorder} limitedtimes={this.limitedtimes} />
                                </div>
                            </div> 
                        </div>

                    </div>
                </div>
                {(this.state.res_donecoupon ? <HandleRes title="Coupon Created successfully" stylecss="alert-success" /> : '')}
                {(this.state.networkError ? <HandleRes title="You are currently offline." stylecss="alert-danger" /> : '')}
                {(this.state.errordatamessage ? <HandleRes title={this.state.errordatamessagetext} stylecss="alert-danger" /> : '')}
                {(this.state.hasError ? <HandleRes title="sorry there was a problem with your request" stylecss="alert-danger" /> : '')}

            </div>
        )
    }
}
export default AdminCoupons;